import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { InvoiceDetailTso } from 'src/apis/capacity-management/types';
import type { InvoicesRequest } from 'src/apis/capacity-management/use-invoices';
import type { MyInvoicesRequest } from 'src/apis/capacity-management/use-my-invoices';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  invoices: MyInvoicesRequest | InvoicesRequest;
  invoiceId: string;
};

type RequestConfig = {
  instanceUrlTemplate: string;
  invoiceId: string;
};

export function useInvoiceForTso({ invoices, invoiceId }: HookConfig) {
  const invoice = useAxios(
    (axios, baseConfig, { instanceUrlTemplate, invoiceId }: RequestConfig) => {
      const url = urlTemplate.parse(instanceUrlTemplate).expand({
        invoiceId,
      });

      return axios.request<InvoiceDetailTso>({
        ...baseConfig,
        url,
      });
    },
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!invoices.response) return;

    const instanceUrlTemplate = invoices.response.data._links.instance.href;

    invoice.execute({
      instanceUrlTemplate,
      invoiceId,
    });

    // oxlint-disable-next-line exhaustive-deps
  }, [invoices.response?.data._links.instance.href, invoiceId]);

  return invoice;
}

export type TsoInvoiceRequest = ReturnType<typeof useInvoiceForTso>;
